/**
 * @file analytics/shop-analytics-track.js
 * @description Producer-side helper for the imperative analytics channel.
 *              Dispatches a CustomEvent that bubbles through Shadow DOM to
 *              the document, where whichever analytics system is active —
 *              legacy ShopAnalytics or fragno's IdmeAnalyticsObserver,
 *              gated by the `fragno_analytics` Flipper flag — forwards it
 *              to GA4. The function signature stays the same regardless of
 *              which system is active, so call sites don't need to know
 *              about the flag.
 */

import { dispatchTrack as fragnoDispatchTrack } from "fragno/analytics";

/**
 * Dispatch a track CustomEvent to whichever analytics system is active.
 *
 * @param {EventTarget} target - Element to dispatch from. Must be in the DOM
 *   so the event can bubble to the document-level observer.
 * @param {string} event - GA4 event name (snake_case).
 * @param {object} [params] - GA4 event params.
 */
export function dispatchTrack(target, event, params = {}) {
  if (window.settings?.fragno_analytics) {
    fragnoDispatchTrack(target, { ga4: { name: event, params } });
    return;
  }

  target.dispatchEvent(
    new CustomEvent("shop:track", {
      bubbles: true,
      composed: true,
      detail: { event, params },
    }),
  );
}
